import type { Provider, ProviderIos } from "./ports";

class Service {
  private readonly provider: Provider;

  constructor(provider: Provider) {
    this.provider = provider;
  }

  create(params: ProviderIos.Create.In) {
    return this.provider.create(params);
  }

  delete(params: ProviderIos.Delete.In) {
    return this.provider.delete(params);
  }

  getMany() {
    return this.provider.getMany();
  }
}

export { Service };
